/**
 * ============================================================================
 * Pricing 模块 - 枚举定义
 * ============================================================================
 * 
 * 📋 文件职责：
 * - 定义产品工价管理模块相关的所有枚举类型
 * - 包含：PriceMode, CalcType, CalcRule, WageRecordStatus 等
 * 
 * 📖 对应后端：
 * - Model: backend/app/Modules/Pricing/Models/ProductPriceConfig.php
 * - Model: backend/app/Modules/Pricing/Models/ProductPrice.php
 * - Model: backend/app/Modules/Pricing/Models/WageRecord.php
 * 
 * ⚠️ 注意事项：
 * - 枚举值必须与后端完全一致
 * - 每个枚举值必须添加中文注释
 * - 使用 TypeScript enum 而不是 type
 * 
 * @module types/pricing/enums
 * @generated Manual (AI-assisted)
 * @last-updated 2025-11-30
 * ============================================================================
 */

/**
 * 计价模式枚举
 * 
 * 对应后端: ProductPriceConfig::PRICE_MODE_*
 */
export enum PriceMode {
  /** 按产品计价 - 一个产品一个工价，不区分工序 */
  PRODUCT = 'PRODUCT',
  
  /** 按工序计价 - 每个工序单独定价 */
  OPERATION = 'OPERATION',
}

/**
 * 计算方式枚举
 * 
 * 对应后端: ProductPriceConfig::CALC_TYPE_*
 */
export enum CalcType {
  /** 计件 - 按完成件数计算 */
  PIECE = 'PIECE',
  
  /** 计时 - 按工作时长计算 */
  TIME = 'TIME',
  
  /** 混合 - 部分工序计件，部分计时 */
  MIXED = 'MIXED',
}

/**
 * 不良品/返工件计算规则枚举
 * 
 * 对应后端: ProductPriceConfig::CALC_RULE_*
 */
export enum CalcRule {
  /** 不计入 - 不良品/返工件不计入工资 */
  EXCLUDE = 'EXCLUDE',
  
  /** 半价 - 按半价计算 */
  HALF = 'HALF',
  
  /** 全价 - 按全价计算 */
  FULL = 'FULL',
}

/**
 * 计价类型枚举
 * 
 * 对应后端: ProductPrice::PRICE_TYPE_*
 */
export enum PriceType {
  /** 计件 - 单位：元/件 */
  PIECE = 'PIECE',
  
  /** 计时 - 单位：元/小时 */
  TIME = 'TIME',
}

/**
 * 审批状态枚举（预留）
 * 
 * 对应后端: ProductPriceConfig::APPROVAL_*
 */
export enum ApprovalStatus {
  /** 无需审批 */
  NONE = 'NONE',
  
  /** 待审批 */
  PENDING = 'PENDING',
  
  /** 已审批 */
  APPROVED = 'APPROVED',
  
  /** 已驳回 */
  REJECTED = 'REJECTED',
}

/**
 * 工资记录状态枚举
 * 
 * 对应后端: WageRecord::STATUS_*
 */
export enum WageRecordStatus {
  /** 待审核 - 刚生成的工资记录 */
  PENDING = 0,
  
  /** 已确认 - 主管/财务确认 */
  CONFIRMED = 1,
  
  /** 已结算 - 工资已发放 */
  SETTLED = 2,
  
  /** 已作废 - 异常作废 */
  VOIDED = 3,
}

/**
 * 通用状态枚举
 * 
 * 对应后端: STATUS_ACTIVE / STATUS_INACTIVE
 */
export enum CommonStatus {
  /** 停用 */
  INACTIVE = 0,
  
  /** 启用 */
  ACTIVE = 1,
}
